import React from 'react';
import Logo from './Logo';
import './Footer.css';

function Footer() {
  const year = new Date().getFullYear();

  const handleNavClick = (e, href) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer>
      <div className="wrap">
        <div className="foot-top">
          <div className="foot-brand">
            <Logo variant="full" />
            <p>
              Custom, end-to-end software that adapts to your business — not the other way
              around.
            </p>
          </div>
          <div className="foot-cols">
            <div className="foot-col">
              <span className="label">Site</span>
              {['approach', 'services', 'process', 'contact'].map((item) => (
                <a
                  key={item}
                  href={`#${item}`}
                  onClick={(e) => handleNavClick(e, `#${item}`)}
                >
                  {item.charAt(0).toUpperCase() + item.slice(1)}
                </a>
              ))}
            </div>
            <div className="foot-col">
              <span className="label">Company</span>
              <a href="mailto:adap8.mksk@gmail.com">adap8.mksk@gmail.com</a>
              <span style={{ display: 'block', fontSize: '14px', color: 'var(--text-2)' }}>
                adap8 intelligence LLP
              </span>
            </div>
          </div>
        </div>
        <div className="foot-bottom">
          <p>© {year} adap8 intelligence LLP. Adapting infinity through innovation.</p>
          <p>Built end-to-end, by adap8.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
